module.exports = "/components/components/linkedPositions-05395f.html";